export default function ShopTitle() {
  return <section data-section-id="222461" id="shop-title" className="relative w-full overflow-hidden bg-background py-24 md:py-32 lg:py-48 flex items-center justify-center">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/botanical_garden_mist.png)]" />

      {}
      <div className="absolute inset-0 bg-background/60 backdrop-blur-[2px]" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-muted/40 to-transparent" />

      {}
      <div className="relative z-10 container mx-auto px-4 text-center flex flex-col items-center">
        <nav className="mb-6 flex items-center gap-2 text-xs md:text-sm font-sans tracking-widest uppercase text-primary/70">
          <span>Home</span>
          <span className="w-1 h-1 rounded-lg bg-primary/30" />
          <span className="text-primary">Shop</span>
        </nav>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-primary tracking-tight font-default drop-shadow-sm">
          The Seasonal Shop
        </h1>
        
        {}
        <div className="w-16 md:w-24 h-px bg-primary/20 mt-8 mb-6 shadow-sm" />
        
        <p className="text-lg md:text-xl text-foreground/80 max-w-2xl font-serif italic leading-relaxed drop-shadow-sm">
          Hand-picked treasures from our garden, blooming just for this fleeting moment.
        </p>
      </div>
    </section>;
}